import React from 'react';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomBox from '@/components/CustomBox/CustomBox';
import { useTranslation } from 'react-i18next';

import styles from './TapGrid.module.scss';
import { CustomBoxPair, CustomBoxProps } from './ContainerTapData';

interface TapGridProps {
  title: string;
  items: CustomBoxProps[];
  date: string;
  dateLabel: string;
}

const TapGrid: React.FC<TapGridProps> = ({ title, items, date, dateLabel }) => {
  const { t } = useTranslation('containerTap');

  const allDescriptionsEmpty = items?.every((item) => !item.description);

  return (
    <div className="w-full">
      <header className="flex flex-column md:flex-row items-center justify-content-between p-4 w-full">
        <h2>{title}</h2>
        {date ? (
          <div className={styles.containerDate}>
            <div className={styles.containerIcon}>
              <FontAwesomeIcon
                className={styles.iconMq}
                icon={faCalendarAlt}
                color="#223466"
              />
              <FontAwesomeIcon
                className={styles.containerDt}
                icon={faCalendarAlt}
                color="white"
              />
            </div>
            <p>
              {dateLabel}: {date}
            </p>
          </div>
        ) : (
          ''
        )}
      </header>
      {!allDescriptionsEmpty && (
        <div className={`grid ${styles.containerTapGrid}`}>
          {items.map((item) => (
            <div key={item.label} className={item?.className || 'col-6'}>
              <CustomBox
                label={item.label}
                icon={item.icon}
                iconColor={item.iconColor}
                description={item.description}
                backgroundColor={item.backgroundColor}
                iconBackgroundColor={item.iconBackgroundColor}
                footer={
                  <div className="grid">
                    <div className="col-6">
                      {item?.pairs?.slice(0, 4).map((pair: CustomBoxPair) => (
                        <div key={pair.label} className="flex flex-column mb-2">
                          <span className="font-bold">{pair.label}</span>
                          <span>{pair.description}</span>
                        </div>
                      ))}
                    </div>
                    <div className="col-6">
                      {item?.pairs?.slice(4).map((pair: CustomBoxPair) => (
                        <div key={pair.label} className="flex flex-column mb-2">
                          <span className="font-bold">{pair.label}</span>
                          <span>{pair.description}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                }
              />
            </div>
          ))}
        </div>
      )}
      {allDescriptionsEmpty && (
        <div className="flex flex-column md:flex-row items-center justify-content-between p-5 w-full">
          {t('noInformationAvailable')}
        </div>
      )}
    </div>
  );
};

export default TapGrid;
